import { getAuth } from "firebase/auth";

export async function forwardModal({
  fromEmail,
  toEmail,
  subject,
  htmlBody,
  textBody,
  attachments,
}) {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("You must be signed in to forward.");
  }

  const token = await user.getIdToken();

  const res = await fetch("/api/forwardModalEmail", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      fromEmail,
      toEmail,
      subject,
      htmlBody,
      textBody,
      attachments,
    }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    throw new Error(data.error || `Forward failed (${res.status})`);
  }

  return data;
}
